<template>
  <v-container
    fluid
    class="mt-0 ml-0 mr-0 pa-0"
    style="margin-bottom:55px; background-color:#FFFFFF"
  >
    <v-row
      v-show="site_logo"
      justify="center"
      class="ma-0 pa-0"
    >
      <v-img
        :src="site_logo"
        class="mx-0 my-2 pa-0"
        max-width="150"
      />
    </v-row>
    <v-row
      justify="center"
      class="ma-0 pa-0"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        lg="3"
        xl="3"
        class="ma-0 pa-0"
      >
        <!-- params.id: {{ $route.params.id }} <br>
        page_id: {{ page_id }}<br> -->
        <v-carousel
          v-show="page_images.length==1"
          :show-arrows="false"
          hide-delimiter-background
          class="ma-0 pa-0"
          height="400"
        >
          <v-carousel-item
            v-for="(item,i) in page_images_sort"
            :key="i"
            :src="item.image_url"
            reverse-transition="fade-transition"
            transition="fade-transition"
            class="ma-0"
          ></v-carousel-item>
        </v-carousel>
        <v-carousel
          v-show="page_images.length>=2"
          :show-arrows="true"
          hide-delimiter-background
          class="ma-0 pa-0"
          height="400"
        >
          <v-carousel-item
            v-for="(item,i) in page_images_sort"
            :key="i"
            :src="item.image_url"
            reverse-transition="fade-transition"
            transition="fade-transition"
            class="ma-0"
          ></v-carousel-item>
        </v-carousel>
        <!-- <div
          v-show="show"
          class="text-center mx-1 my-0"
        >
          <p
            ref="page_name"
            style="display:inline-block;"
            class="px-5 py-2"
          >
            {{ page_name }}
          </p>
        </div> -->
        <div
          class="mt-1 mx-1 mb-5 pt-2 px-2 pb-5"
        >
          <div
            v-show="show"
            ref="page_markdown"
            class="markdown"
            v-html="compiledMarkdown"
          />
        </div>
      </v-col>
    </v-row>
    <v-btn
      v-show="voice_open"
      style="bottom: 100px"
      :color="site_color"
      absolute
      right
      fab
      fixed
      x-large
    >
      <voice-modal
        ref="voiceModal"
        justify="start"
        icon="mdi-account-voice"
        card_title="Share your product experience."
      />
    </v-btn>
  </v-container>
</template>
<script>
  import { storageRef } from '../../plugins/firebase.js'
  import { marked } from 'marked'
  export default {
    name: 'Pages',
    components: {
      VoiceModal: () => import('./VoiceModal.vue'),
    },
    data: () => ({
      site_id: '',
      site_url: '',
      page_id: '',
      // page_name: '',
      page_markdown: '',
      voice_open: '',
      voice_name: '',
      voice_markdown: '',
      voice_url: '',
      page_images: [],
      page_images_sort: [],
      show: false,
      // ref_page_name: '',
      ref_page_markdown: '',
      site_logo: '',
      site_color: '',
    }),
    computed: {
      compiledMarkdown: function () {
        return marked(this.page_markdown)
      },
    },
    created () {
      this.site_url = this.$store.state.site_url
      this.site_logo = this.$store.state.site_logo
      this.site_color = this.$store.state.site_color
      // レビュー画面から来たときだけ表示したい（レビューのときなぜか mutation変更でのviewPage動かない）
      if (this.$store.state.from_review === true) {
        this.page_id = this.$store.state.page_id
        // this.page_name = this.$store.state.page_name
        this.page_markdown = this.$store.state.page_markdown
        this.voice_open = this.$store.state.voice_open
        this.voice_name = this.$store.state.voice_name
        this.voice_markdown = this.$store.state.voice_markdown
        this.voice_url = this.$store.state.voice_url
        this.viewPage()
      }
    },
    mounted () {
      // mountedしたら、DOM操作用のrefを取得する
      // this.ref_page_name = this.$refs.page_name
      this.ref_page_markdown = this.$refs.page_markdown
      // Vuexの値が変更完了したタイミングでの通知
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'SET_PAGE_ID') {
          this.page_id = state.page_id
          this.show = false
          // mountedからviewPageが2回呼び出される問題の対策
          setTimeout(() => {
            this.viewPage()
          }, 300)
        }
        // if (mutation.type === 'SET_PAGE_NAME') {
        //   this.page_name = state.page_name
        // }
        if (mutation.type === 'SET_PAGE_MARKDOWN') {
          this.page_markdown = state.page_markdown
        }
        if (mutation.type === 'SET_SITE_LOGO') {
          this.site_logo = state.site_logo
        }
        if (mutation.type === 'SET_SITE_COLOR') {
          this.site_color = state.site_color
        }
        if (mutation.type === 'SET_VOICE_OPEN') {
          this.voice_open = state.voice_open
          console.log(this.voice_open)
          if (this.voice_open) {
            setTimeout(() => {
              this.$refs.voiceModal.open()
            }, 1000)
          }
        }
        if (mutation.type === 'SET_VOICE_NAME') {
          this.voice_name = state.voice_name
        }
        if (mutation.type === 'SET_VOICE_MARKDOWN') {
          this.page_markdown = state.page_markdown
        }
        if (mutation.type === 'SET_VOICE_URL') {
          this.voice_url = state.voice_url
        }
      })
    },
    methods: {
      viewPage: function () {
        this.page_images = []
        this.page_images_sort = []
        // Create a reference under which you want to list
        const listRef = storageRef.child(this.$store.state.partner_id + '/pages/' + this.$store.state.page_id)
        // Find all the prefixes and items.
        listRef.listAll()
          .then((res) => {
            res.items.forEach((itemRef) => {
              // All the items under listRef.
              itemRef.getDownloadURL()
                .then((url) => {
                  // Insert url into an <img> tag to "download"
                  const image = {
                    image_url: '',
                    image_ref: '',
                  }
                  image.image_url = url
                  image.image_ref = itemRef
                  this.page_images.push(image)
                  // 画像名の日時順に並べ替え
                  this.page_images_sort = this.page_images.sort(function (a, b) {
                    return (a.image_url > b.image_url) ? -1 : 1
                  })
                })
            })
            // 写真を読み込みDOMが表示完了時に
            this.show = true
            this.setCSS()
          }).catch((error) => {
            console.log(error)
          })
      },
      setCSS: function () {
        // DOMに直接CSSを当てる
        // this.ref_page_name.style.color = this.$store.state.site_color
        // this.ref_page_name.style.fontSize = '30px'
        // this.ref_page_name.style.fontWeight = '500'
        // // 上下にdashed
        // this.ref_page_name.style.borderTop = `4px dashed ${this.$store.state.site_color}`
        // this.ref_page_name.style.borderBottom = `4px dashed ${this.$store.state.site_color}`
        // this.ref_page_name.style.margin = '32px 0px 5px'
        // markdownのHTMLタグの種類ごとにCSSをあてる
        const aElems = this.ref_page_markdown.getElementsByTagName('a')
        aElems.forEach(elem => {
          elem.style.color = this.$store.state.site_color
        })
        const tableElems = this.ref_page_markdown.getElementsByTagName('table')
        tableElems.forEach(elem => {
          elem.style.width = '100%'
          elem.style.border = 'solid #666 1px'
          elem.style.borderCollapse = 'collapse'
          elem.style.margin = '32px 0px 32px'
        })
        const thElems = this.ref_page_markdown.getElementsByTagName('th')
        thElems.forEach(elem => {
          elem.style.textAlign = 'left'
          elem.style.border = 'solid #666 1px'
          elem.style.padding = '3px 10px'
          elem.style.color = '#fff'
          elem.style.backgroundColor = this.$store.state.site_color
        })
        const tdElems = this.ref_page_markdown.getElementsByTagName('td')
        tdElems.forEach(elem => {
          elem.style.border = 'solid #666 1px'
          elem.style.padding = '3px 10px'
        })
        const h1Elems = this.ref_page_markdown.getElementsByTagName('h1')
        h1Elems.forEach(elem => {
          elem.style.background = '#f9f9f9'
          elem.style.borderLeft = `6px solid ${this.$store.state.site_color}`
          elem.style.paddingLeft = '10px'
          elem.style.margin = '32px 0px 5px'
        })
        const h2Elems = this.ref_page_markdown.getElementsByTagName('h2')
        h2Elems.forEach(elem => {
          elem.style.background = '#f9f9f9'
          elem.style.borderLeft = `6px solid ${this.$store.state.site_color}`
          elem.style.paddingLeft = '10px'
          elem.style.margin = '32px 0px 5px'
        })
        const h3Elems = this.ref_page_markdown.getElementsByTagName('h3')
        h3Elems.forEach(elem => {
          elem.style.background = '#f9f9f9'
          elem.style.borderLeft = `6px solid ${this.$store.state.site_color}`
          elem.style.paddingLeft = '10px'
          elem.style.margin = '32px 0px 5px'
        })
        const h4Elems = this.ref_page_markdown.getElementsByTagName('h4')
        h4Elems.forEach(elem => {
          elem.style.background = '#f9f9f9'
          elem.style.borderLeft = `6px solid ${this.$store.state.site_color}`
          elem.style.paddingLeft = '10px'
          elem.style.margin = '32px 0px 5px'
        })
        const iflameElems = this.ref_page_markdown.getElementsByTagName('iflame')
        iflameElems.forEach(elem => {
          elem.style.margin = '16px 0px 16px'
        })
        const imgElems = this.ref_page_markdown.getElementsByTagName('img')
        imgElems.forEach(elem => {
          elem.style.margin = '16px 0px 16px'
        })
        const iframeElems = this.ref_page_markdown.getElementsByTagName('iframe')
        iframeElems.forEach(elem => {
          elem.style.width = '100%'
        })
      },
    },
  }
</script>
<style>
  #app {
    /* font-family: 'Yusei Magic', sans-serif; */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .markdown{
    color:#444;
    line-height:2.0;
  }
</style>
